var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "auto-logout-wrapper" }, [
    _c("div", { staticClass: "small-title bold" }, [
      _vm._v(_vm._s(_vm.$t("setting.autoLogout")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "describe" }, [
      _vm._v(_vm._s(_vm.$t("setting.logoutDescribe")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting common-list-wrapper __pointer" }, [
      _c(
        "span",
        {
          staticClass: "list-title",
          class: {
            down: !_vm.showTime,
            up: _vm.showTime
          },
          on: { click: _vm.toggletimeList }
        },
        [_vm._v(_vm._s(_vm.$t("setting.timeList." + _vm.autoLogoutTime)))]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showTime,
              expression: "showTime"
            }
          ],
          staticClass: "list"
        },
        _vm._l(_vm.timeList, function(time, index) {
          return _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: time !== _vm.autoLogoutTime,
                  expression: "time !== autoLogoutTime"
                }
              ],
              key: index,
              on: {
                click: function($event) {
                  return _vm.setTime(time)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("setting.timeList." + time)))]
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }